<style lang="scss" scoped>
.drop_selector{
  color:#fff;
  cursor: pointer;
  position:relative;
  .ds_name{
    text-transform: uppercase;
  }
  .caret_ls{
    font-size:14px;
    margin:0px 5px;
  }
  .submenu{
    color: #2A3E6D;
    position: absolute;
    background: #fff;
    top: 100%;
    left: auto;
    right:-11px;
    display: flex;
    flex-direction: column;
    padding: 8px 24px;
    margin-top: 5px;
    border-radius: 8px;
    .lang_item{
      font-weight: 600;
      &.active, &:hover, &:focus{
        outline:none;
        text-decoration: underline;
      }
    }
  }
}
</style>
<!-- //Removed until we get our first translation
<template>
  <div ref="menuLangs" class='language_selector_outer' v-if='selectedLang'>
    <span class="drop_selector">
      <span class="ds_name" @click.stop.prevent="toggleMenu">
        <span @focus="setFocusMenu" tabindex="0">
          {{ selectedLang }}
          <i v-if="showMenu" class="fa fa-caret-down caret_ls" aria-hidden="true"></i>
          <i v-else class="fa fa-caret-right caret_ls" aria-hidden="true"></i>
        </span>
      </span>
      <div ref="subMenu" class="submenu" v-if="showMenu">
        <div @focus="setFocusMenu" tabindex="0" @click="setLang('en')" class="lang_item" :class="{active: selectedLang === 'en'}">EN</div>
        <div @focus="setFocusMenu" tabindex="0" @click="setLang('fr')" class="lang_item" :class="{active: selectedLang === 'fr'}">FR</div>
        <div @focus="setFocusMenu" tabindex="0" @click="setLang('ch')" class="lang_item" :class="{active: selectedLang === 'ch'}">CH</div>
      </div>
    </span>
  </div>
</template>
-->
<script>
export default {
  props:{
    openLangMenu:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMenu: false
    };
  },
  computed: {
    selectedLang(){
      return window.siteLanguage;
    }
  },
  watch:{
    openLangMenu(){
      this.showMenu = this.openLangMenu;
    },
    showMenu(){
      this.$emit('update:openLangMenu', this.showMenu);
    },
  },
  mounted () {
    window.langMenu = this;
    this.showMenu = this.openLangMenu;
  },
  methods: {
    setFocusMenu(){
      this.allowChangeMenu = false;
      this.showMenu = true;
      setTimeout(() => {
        this.allowChangeMenu = true;
      }, 400)
    },
    setLang(name){
      this.$http.post('/switch-language', {
          lang: name
        })
        .then(() => {
          location.reload();
        });
    },
    toggleMenu(){
      if(this.allowChangeMenu){
        this.showMenu = !this.showMenu;
      }
    },
    documentClick(e){
      let el = this.$refs.menuLangs;
      if(!el){
        return;
      }
      let target = e.target;
      if(( el !== target) && !el.contains(target)) {
        this.showMenu = false;
      }
    },
  },
  created () {
    document.addEventListener('click', this.documentClick);
  },
  destroyed () {
    document.removeEventListener('click', this.documentClick);
  },
}
</script>
